import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import MainSidebar from './components/MainSidebar';
import MobileNavBar from './components/MobileTopBar/MobileNavBar';
import FloorPlanScreen from './Screens/FloorPlanScreen/FloorPlanScreen';
import DashboardScreen from './Screens/DashboardScreen';
import LoginScreen from './Screens/LoginScreen/LoginScreen';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';
import CustomersListScreen from './Screens/CustomersListScreen/CustomersListScreen';
import 'react-toastify/dist/ReactToastify.css';
import EditScreen from './Screens/EditScreen/EditScreen';
import Emails from './Screens/Email/Emails';
import EmailEdit from './Screens/EmailEditor/EmailEdit';

const queryClient = new QueryClient();

const MainApp = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    document.title = 'Free Table Admin';
    const favicon = document.querySelector("link[rel~='icon']");
    if (!favicon) {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = 'https://qglldlnkkypojvppmqzs.supabase.co/storage/v1/object/public/restoranisliki/favicon.png';
      document.head.appendChild(link);
    } else {
      favicon.href = 'https://qglldlnkkypojvppmqzs.supabase.co/storage/v1/object/public/restoranisliki/favicon.png';
    }
  }, []);

  return (
    <div className="app-container">
      {isMobile ? <MobileNavBar /> : <MainSidebar />}
      <div className="main-content">
        <Routes>
          <Route path="/dashboard" element={<DashboardScreen />} />
          <Route path="/email" element={<Emails />} />
          <Route path="/floor-plan" element={<FloorPlanScreen />} />
          <Route path="/customers" element={<CustomersListScreen />} />
          <Route path="/" element={<FloorPlanScreen />} />
          <Route path="/edit" element={<EditScreen />} />
          <Route path="/emails/edit/:templateKey/:language" element={<EmailEdit />} />
        </Routes>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginScreen />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <MainApp />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;